/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.


//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container: ' + container);
//       console.log('Variant: ' + variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart: ' + cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });

//   // Debounced scroll listeners.  Up and down only fire on directions changes
//   // These events are useful for creating sticky headers and footers.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
  
	
    //Header Utility Width
	(function() {
      function utilWidth(){
        if(document.getElementsByClassName('announcement__left')[0]){
        var announcementLeftWidth = document.getElementsByClassName('announcement__left')[0].clientWidth,
          announcementRightWidth = document.getElementsByClassName('announcement__right')[0].clientWidth;
        if (announcementLeftWidth > announcementRightWidth) {
            document.documentElement.style.setProperty('--announcement-cap-width', `${(announcementLeftWidth)}px`);
        } else if (announcementLeftWidth < announcementRightWidth) {
            document.documentElement.style.setProperty('--announcement-cap-width', `${(announcementRightWidth)}px`);
        }
        }
      }
      utilWidth();
      window.addEventListener('resize', utilWidth);
    })();
  
    //Logo width  
    (function() {
      function logoWidth(){
        var logoWidth = document.getElementsByClassName('header__logo__link')[0].clientWidth;
        document.documentElement.style.setProperty('--logo-width', `${(logoWidth)}px`);
      }
      logoWidth();
      window.addEventListener('resize', logoWidth);
    })();
  
  
    //Header Split
    (function() {

      var navbarMenu = document.querySelectorAll('.header__desktop__bar__b .header__menu')[0],
          navbarNav = document.querySelectorAll('.header__desktop__bar__b .header__menu__inner')[0],
          split = document.querySelectorAll('.header__desktop__bar__b .header__menu__inner .menu__item').length / 2, //hacky hack +1
          breakpoint = 1025;

      navbarNav.insertAdjacentHTML('afterend', '<div class="header__menu__inner header__menu__inner--split"></div>');
      
      var navbarNavSplit = document.querySelectorAll('.header__desktop__bar__b .header__menu__inner--split')[0],
          navbarNavItemSplit = document.querySelectorAll('.header__desktop__bar__b .header__menu__inner .menu__item:nth-of-type('+ Math.floor(split) +') ~ .menu__item');

      function navSplit(){
      if (window.matchMedia('(min-width: '+ breakpoint +'px)').matches) {
          for (var i = 0; i < navbarNavItemSplit.length; i++) {
            navbarNavSplit.appendChild(navbarNavItemSplit[i]);
          }
          navbarMenu.classList.add('has-split');
        } else {
          for (var i = 0; i < navbarNavItemSplit.length; i++) {
            navbarNav.appendChild(navbarNavItemSplit[i]);
          }
          navbarMenu.classList.remove('has-split');
        }
      }

      navSplit();
      window.addEventListener('resize', navSplit);
    })();
  
  	
    // Product Description Tabs
    $('.product-description .tabs-content li').hide();
    $('.product-description .tabs li a').each(function(){
      var position = $(this).parent('li').index() + 1;
      $(this).on('click', function(e){
        e.preventDefault();
        $(this).parent('li').addClass('active');
        $(this).parent('li').siblings().removeClass('active');
        $('.tabs-content li').hide();
        $('.tabs-content li:nth-of-type('+position+')').show();
      });
      $('.tabs li:nth-of-type(1) a').trigger('click');
    });

  
  
    $('.header__desktop__bar__b .menu__item.grandparent, .header__desktop__bar__b .menu__item.parent').hover(
      function() {
        $(this).addClass("is-visible");
        $(this).children('.header__dropdown').addClass("is-visible");
      }, function() {
        $(this).removeClass("is-visible");
        $(this).children('.header__dropdown').removeClass("is-visible");
      }
    );

    // SUBNAV HEADERS
    $('.dropdown__family > .navlink--child[href="#"]').each(function(){
      if($(this).siblings('.navlink--grandchild')){
        let headerMenuText = $(this).text().trim().toUpperCase();
        let newHeaderMenuItem = `<div class="menu-subheader navlink--child">${headerMenuText}</div>`;
        $(this).replaceWith(newHeaderMenuItem);
        $('.menu-subheader').css({'font-size':'1.3rem','font-weight': '400', 'border-bottom': '2px solid rgba(112,112,112,0.25)'});
      }
    });
   
})();

var checkAnnouncementTextLoaded = setInterval(function(){ 
    if(document.querySelectorAll('.announcement__text:not(.ticker__comparitor)')[0] === undefined ) {
        console.log('not loaded');
    } else {
        console.log('loaded');
        clearInterval(checkAnnouncementTextLoaded);
          loadAnnouncementAdditionalCode();
    }
}, 2000);

var loadAnnouncementAdditionalCode = function(){
  if ($(window).width() < 967) {
    $('.announcement__scale > .announcement__text').addClass('ticker--animated');
  }
}



jQuery(function(){
  jQuery(window).scroll(function(){
    var shpannounc=0;
    var shpsection=0;
    if(jQuery('#shopify-section-announcement').length!=0){
    	shpannounc = jQuery('#shopify-section-announcement').height();
    }
    if(jQuery('#shopify-section-header').length!=0){
    	shpsection = jQuery('#shopify-section-header').height();
    }
    var finalHeight = (eval(shpannounc)+eval(shpsection));
    if(jQuery(this).scrollTop()>=finalHeight){
      if(shpannounc!=0){
      	jQuery('#shopify-section-announcement').addClass('sticky');
      }
      if(shpsection!=0){
      	jQuery('#shopify-section-header').addClass('sticky');
      }
    }else{
    	jQuery('#shopify-section-announcement').removeClass('sticky');
      	jQuery('#shopify-section-header').removeClass('sticky');
    }
  });
});


// Show the first tab and hide the rest
    $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();

      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });


